//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ISTHNONOVERTDIC",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "2", name: "有" },
        { value: "0", name: "无" },
      ],
      dataList1: [
        { value: "0", name: ">100×10⁹/L" },
        { value: "-1", name: "增加" },
        { value: "1", name: "<100×10⁹/L" },
        { value: "1", name: "减少" },
      ],
      dataList2: [
        { value: "0", name: "<3秒" },
        { value: "-1", name: "不延长" },
        { value: "1", name: ">3秒" },
        { value: "1", name: "延长" },
      ],
      dataList3: [
        { value: "0", name: "正常" },
        { value: "-1", name: "不升高" },
        { value: "1", name: "升高" },
        { value: "1", name: "升高" },
      ],
      dataList4: [
        { value: "-1", name: "正常" },
        { value: "1", name: "降低" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ISTHNONOVERTDIC.vue